import {useQuery} from '@tanstack/react-query'
import {useAccessToken} from '@salesforce/commerce-sdk-react'
import {getConfig} from '@salesforce/pwa-kit-runtime/utils/ssr-config'
import {useAppOrigin} from '@salesforce/retail-react-app/app/hooks/use-app-origin'
import {useCurrentCustomer} from '@salesforce/retail-react-app/app/hooks/use-current-customer'
import {doCustomAPICall} from '../utils/custom-api-utils'
import {getUserIdentifiers} from '../utils/custom-utils'

export const useThinkAnalyticsProductRecommendations = (slotData, geoData, queryOptions = {}) => {
    const {getTokenWhenReady} = useAccessToken()
    const config = getConfig()
    const appOrigin = useAppOrigin()
    const {data: customer} = useCurrentCustomer()

    const customAPIFolderName = 'think-analytics'
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone
    const userAgent = typeof window !== 'undefined' ? window.navigator.userAgent : ''
    const {userID, householdId} = getUserIdentifiers(customer)

    const isQueryEnabled = queryOptions?.enabled && !!slotData && !!geoData

    const geoLocalData = {
        countryCode: geoData?.CountryCode || '',
        regionCode: geoData?.RegionCode || '',
        timeZone: geoData?.timeZone || timeZone || ''
    }

    localStorage.setItem('taGeoData', JSON.stringify(geoLocalData))

    const {data, isLoading, error} = useQuery({
        queryKey: ['think-analytics-recommendations', slotData, geoData],
        enabled: isQueryEnabled,
        queryFn: async () => {
            const queryParams = new URLSearchParams({
                ...(geoData?.CountryCode && {c_countryCode: geoData.CountryCode}),
                ...(geoData?.RegionCode && {c_regionCode: geoData.RegionCode}),
                ...{c_timeZone: timeZone || ''},
                ...(userAgent && {c_userAgent: userAgent}),
                ...(userID && {c_userID: userID}),
                ...(householdId && {c_householdId: householdId}),
                ...(slotData.useCase && {c_useCase: slotData.useCase}),
                ...(slotData.filterOne && {c_filterOne: slotData.filterOne}),
                ...(slotData.filterOneValue && {c_filterOneValue: slotData.filterOneValue}),
                ...(slotData.filterTwo && {c_filterTwo: slotData.filterTwo}),
                ...(slotData.filterTwoValue && {c_filterTwoValue: slotData.filterTwoValue})
            })

            const apiPath = `${customAPIFolderName}?${queryParams.toString()}`

            return doCustomAPICall(getTokenWhenReady, {
                config,
                appOrigin,
                customAPIFolderName,
                apiPath
            })
        }
    })

    return {
        data: data || [],
        isLoading,
        error
    }
}
